import { toSentenceCase } from "utils/common";
import { handleInvalidRequest } from "utils/sdk";

import { MenuItem } from "components/Menu";

import { useDealChecklistPermission } from "entities/Deal/sdk";
import { EFieldStatus } from "entities/Field/constants";
import FieldStatusIcon from "entities/Package/components/FieldStatusIcon";
import { fieldStatusBulkUpdate } from "entities/Package/sdk";

export interface IStatusSelector {
  dealId: number;
  fieldIds: Array<number>;
  companyPackageId: number;
  successCallback: ({ message }: { message?: string }) => void;
}

const StatusSelector = ({
  dealId,
  companyPackageId,
  fieldIds,
  successCallback,
}: IStatusSelector) => {
  const { data: userPermission } = useDealChecklistPermission({
    dealId,
    packageId: companyPackageId,
  });

  const handleClick = ({ status }: { status: EFieldStatus }) => {
    fieldStatusBulkUpdate({ fieldIds, status, companyPackageId, dealId })
      .then(() =>
        successCallback({
          message: `Status updated to ${status}`,
        })
      )
      .catch(handleInvalidRequest);
  };

  return (
    <>
      <MenuItem
        sx={{ gap: 1 }}
        onClick={() => handleClick({ status: EFieldStatus.NOT_DONE })}
        dataTestid="not-done-option"
      >
        <FieldStatusIcon status={EFieldStatus.NOT_DONE} />
        {toSentenceCase({ text: EFieldStatus.NOT_DONE })}
      </MenuItem>
      <MenuItem
        sx={{ gap: 1 }}
        onClick={() => handleClick({ status: EFieldStatus.DONE })}
        dataTestid="done-option"
      >
        <FieldStatusIcon status={EFieldStatus.DONE} />
        {toSentenceCase({ text: EFieldStatus.DONE })}
      </MenuItem>

      {userPermission?.is_checklist_owner && (
        <MenuItem
          sx={{ gap: 1 }}
          disabled={!userPermission?.is_checklist_owner}
          onClick={() => handleClick({ status: EFieldStatus.IN_REVIEW })}
          dataTestid="in-review-option"
        >
          <FieldStatusIcon status={EFieldStatus.IN_REVIEW} />
          {toSentenceCase({ text: EFieldStatus.IN_REVIEW })}
        </MenuItem>
      )}
      {userPermission?.is_checklist_owner && (
        <MenuItem
          sx={{ gap: 1 }}
          disabled={!userPermission?.is_checklist_owner}
          onClick={() => handleClick({ status: EFieldStatus.SATISFIED })}
          dataTestid="satisfied-option"
        >
          <FieldStatusIcon status={EFieldStatus.SATISFIED} />
          {toSentenceCase({ text: EFieldStatus.SATISFIED })}
        </MenuItem>
      )}

      {userPermission?.is_full_access && (
        <MenuItem
          sx={{ gap: 1 }}
          disabled={!userPermission?.is_full_access}
          onClick={() => handleClick({ status: EFieldStatus.NA })}
          dataTestid="na-option"
        >
          <FieldStatusIcon status={EFieldStatus.NA} />
          {toSentenceCase({ text: EFieldStatus.NA })}
        </MenuItem>
      )}
    </>
  );
};
export default StatusSelector;
